import {
  Button,
  Icon,
  InformationCard,
  Text,
  useIsMobile
} from '@yes.technology/react-toolkit'
import { useTranslation } from 'react-i18n-lite'

type Props = {
  isOpen: boolean
  onClose: () => void
  title: string
}

const PermissionDeniedCard = ({ isOpen, onClose, title }: Props) => {
  const { t } = useTranslation()
  const isMobile = useIsMobile()

  return (
    <InformationCard
      title={title}
      spacingClass='small'
      close={onClose}
      style={{
        width: '100%',
        maxWidth: isMobile ? '90vw' : '600px',
        padding: '32px',
        position: 'fixed',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        margin: 0
      }}
      isOpen={isOpen}
      hideHeader
    >
      <div className='d-flex flex-column gap-4'>
        <Text variant='label-required-04'>{title}</Text>
        <div className='d-flex align-self-center my-4'>
          <Icon iconName='Close' icSize='extraGiant' icColor='_006BFF' />
        </div>
        <Text variant='content-04'>{t('permission.denied.complement')}</Text>
        <Button variant='secondary' onClick={onClose}>
          {t('permission.denied.close')}
        </Button>
      </div>
    </InformationCard>
  )
}

export default PermissionDeniedCard
